import {downloadString} from "./CollectionImage";
import {defaultPrompt} from '../containers/Generate'

export const copyDescriptionToClipboard = async (imageDescription, setClipboardMessage) => {
    try {
        // Strip out the first part of the description
        await navigator.clipboard.writeText(imageDescription.replace(/This image shows|This image illustrates|This image features/g, ""));
        setClipboardMessage('Description copied to clipboard!');
    } catch (error) {
        console.error('Failed to copy text:', error);
        setClipboardMessage('Failed to copy description!');
    }
};

export const downloadDescriptionAsPromptFile = async (imageDescription, downloadName) => {
    console.log("DOWNLOADING DESCRIPTION AS PROMPT FILE")
    let newPrompt = defaultPrompt;
    // Strip out the first part of the description
    newPrompt.prompt.prompt = imageDescription.replace(/This image shows|This image illustrates|This image features/g, "");
    downloadString(JSON.stringify(newPrompt), 'application/json', `${downloadName}.prompt`);
};

export const populatePromptField = (imageDescription, updatePrompt) => {
    console.log("Setting Prompt to ", imageDescription)
    // Strip out the first part of the description
    updatePrompt(imageDescription.replace(/This image shows|This image illustrates|This image features/g, ""));
};
